[...document.querySelectorAll('form')].forEach(form => {
  // Loop the form elements
  [...form.elements].forEach(element => {
    const label = document.querySelector(`label[for="${element.id}"]`) || false;
    // If there is no label, return
    if (!label) return;
    // If the element is a select, return
    if (element.tagName === 'SELECT') return;
    // If the element is a button, return
    if (element.tagName === 'BUTTON') return;
    // If the element is a checkbox, return
    if (element.type === 'checkbox') return;
    // If the element is a radio, return
    if (element.type === 'radio') return;
    // If the element is a file, return
    if (element.type === 'file') return;
    // If the element is a submit, return
    if (element.type === 'submit') return;
    // If the element is a reset, return
    if (element.type === 'reset') return;
    // If the element is a button, return
    if (element.type === 'button') return;
    // If the element is a hidden, return
    if (element.type === 'hidden') return;
    // If the element is a textarea, return
    if (element.tagName === 'TEXTAREA') return;
    // If the element has a placeholder, return
    if (element.placeholder) return;

    // Otherwise, add the placeholder text, grab it from the label
    element.placeholder = label.textContent || '';

    // Add a class to the element's parent
    label.classList.add('has-placeholder');
  });
});